import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {LinearProgress, LinearProgressProps} from '@mui/material';

function LinearProgressWithLabel(props: LinearProgressProps & {value: number}) {
    return (
        <Box sx={{display: 'flex', alignItems: 'center'}}>
            <Box sx={{width: '100%', mr: 1}}>
                <LinearProgress variant='determinate' {...props} />
            </Box>
            <Box sx={{minWidth: 35}}>
                <Typography variant='body2' sx={{color: 'text.secondary'}}>{`${Math.round(props.value)}%`}</Typography>
            </Box>
        </Box>
    );
}

export default function LinearProgressIndicator(props: {progress: number}) {
    return (
        <Box sx={{width: '100%'}}>
            <LinearProgressWithLabel value={props.progress} />
        </Box>
    );
}
